import * as changeCase from 'change-case'

export default {
  async install(Vue) {
    Vue.prototype.$changeCase = changeCase
  }
}
